import { Column } from 'features/ExportModal/model/types';
import { TFunction } from 'i18next';

export const getLeadColumnKeys = (t: TFunction): Column[] => {
  return [
    {
      key: 'name',
      title: t('Name'),
    },
    {
      key: 'email',
      title: t('Email'),
    },
    {
      key: 'phone',
      title: t('Phone'),
    },
    {
      key: 'warehouseId',
      title: t('Warehouse'),
    },
    {
      key: 'createdAt',
      title: t('Date'),
    },
    {
      key: 'square',
      title: t('Box size'),
    },
    {
      key: 'isLeft',
      title: t('Left'),
    },
    {
      key: 'note',
      title: t('Note'),
    },
    {
      key: 'contractId',
      title: t('Active contract'),
    },
    {
      key: 'isContractPaid',
      title: t('Active contract but not paid'),
    },
    {
      key: 'contractEndDate',
      title: t('Ended contract'),
    },
    {
      key: 'firstContact',
      title: t('First contact'),
    },
    {
      key: 'leaveReason',
      title: t('Leave reason'),
    },
    {
      key: 'googleClickId',
      title: t('Google click ID'),
    },
    {
      key: 'googleClickIdDate',
      title: t('Google click ID Date'),
    },
  ];
};

export const getUserColumnKeys = (t: TFunction): Column[] => {
  return [
    {
      key: 'name',
      title: t('Name'),
    },
    {
      key: 'email',
      title: t('Email'),
    },
    {
      key: 'phone',
      title: t('Phone'),
    },
    {
      key: 'createdAt',
      title: t('Date'),
    },
    {
      key: 'userDebt',
      title: t('Debt'),
    },
    {
      key: 'note',
      title: t('Note'),
    },
  ];
};

export const getContractColumnKeys = (t: TFunction): Column[] => {
  return [
    {
      key: 'warehouse',
      title: t('Warehouse'),
    },
    {
      key: 'contractNumber',
      title: t('Contract number'),
    },
    {
      key: 'boxItem',
      title: t('Box'),
    },
    {
      key: 'boxItemSquare',
      title: t('Square'),
    },
    {
      key: 'customerEmail',
      title: t('Customer'),
    },
    {
      key: 'customerName',
      title: t('Name'),
    },
    {
      key: 'customerPhone',
      title: t('Phone'),
    },
    {
      key: 'createdAt',
      title: t('Date of creation'),
    },
    {
      key: 'startDate',
      title: t('Arrival Date'),
    },
    {
      key: 'noticeLeaveDate',
      title: t('Planned Departure Date'),
    },
    {
      key: 'leaveDate',
      title: t('Closing Date'),
    },
    {
      key: 'overduePeriods',
      title: t('Overdue Periods'),
    },
    {
      key: 'totalDebt',
      title: t('Debt'),
    },
  ];
};

export const getInvoiceColumnKeys = (t: TFunction): Column[] => {
  return [
    {
      key: 'warehouse',
      title: t('Warehouse'),
    },
    {
      key: 'documentNumber',
      title: t('Invoice number'),
    },
    {
      key: 'contractNumber',
      title: t('Contract number'),
    },
    {
      key: 'unitType',
      title: t('Unit type'),
    },
    {
      key: 'customer',
      title: t('Customer'),
    },
    {
      key: 'phone',
      title: t('Phone'),
    },
    {
      key: 'email',
      title: t('Email'),
    },
    {
      key: 'country',
      title: t('Country'),
    },
    {
      key: 'city',
      title: t('City'),
    },
    {
      key: 'street',
      title: t('Street'),
    },
    {
      key: 'house',
      title: t('House'),
    },
    {
      key: 'apartment',
      title: t('Apartment'),
    },
    {
      key: 'zipCode',
      title: t('Zip code'),
    },
    {
      key: 'extendedAmount',
      title: t('Invoice items details'),
    },
    {
      key: 'amount',
      title: t('Amount'),
    },
    {
      key: 'debt',
      title: t('Debt'),
    },
    {
      key: 'payments',
      title: t('Paid'),
    },
    {
      key: 'refunds',
      title: t('Refunded'),
    },
    {
      key: 'creditNotes',
      title: t('Credited'),
    },
    {
      key: 'createdAt',
      title: t('Created date'),
    },
    {
      key: 'dueDate',
      title: t('Due date'),
    },
    {
      key: 'dateFrom',
      title: t('Date from'),
    },
    {
      key: 'dateTo',
      title: t('Date to'),
    },
  ];
};

export const getBoxColumnKeys = (t: TFunction): Column[] => {
  return [
    {
      key: 'name',
      title: t('Box'),
    },
    {
      key: 'contractNumber',
      title: t('Contract'),
    },
    {
      key: 'reservationNumber',
      title: t('Reservation'),
    },
    {
      key: 'rates',
      title: t('Cost'),
    },
    {
      key: 'square',
      title: t('Square'),
    },
    {
      key: 'warehouseName',
      title: t('Warehouse'),
    },
    {
      key: 'lockAddress',
      title: t('Lock number'),
    },
    {
      key: 'lockStatus',
      title: t('Lock status'),
    },
    {
      key: 'lastOpened',
      title: t('Last opened'),
    },
    {
      key: 'userEmail',
      title: t('Customer'),
    },
    {
      key: 'isActive',
      title: t('Availability'),
    },
    {
      key: 'floorName',
      title: t('Floor'),
    },
    {
      key: 'note',
      title: t('Note'),
    },
  ];
};

export const getCreditNoteColumnKeys = (t: TFunction): Column[] => {
  return [
    {
      key: 'warehouse',
      title: t('Warehouse'),
    },
    {
      key: 'documentNumber',
      title: t('Credit Note number'),
    },
    {
      key: 'customer',
      title: t('Customer'),
    },
    {
      key: 'creditNoteType',
      title: t('Credit Note Target'),
    },
    {
      key: 'creditedDocumentNumber',
      title: t('Credited document number'),
    },
    {
      key: 'creditedAmount',
      title: t('Amount'),
    },
    {
      key: 'extendedAmount',
      title: t('Invoice items details'),
    },
    {
      key: 'phone',
      title: t('Phone'),
    },
    {
      key: 'email',
      title: t('Email'),
    },
    {
      key: 'country',
      title: t('Country'),
    },
    {
      key: 'city',
      title: t('City'),
    },
    {
      key: 'street',
      title: t('Street'),
    },
    {
      key: 'house',
      title: t('House'),
    },
    {
      key: 'apartment',
      title: t('Apartment'),
    },
    {
      key: 'zipCode',
      title: t('Zip code'),
    },
    {
      key: 'createdAt',
      title: t('Created date'),
    },
  ];
};

export const getInsuranceColumnKeys = (t: TFunction): Column[] => {
  return [
    {
      key: 'userFullName',
      title: t('Customer'),
    },
    {
      key: 'warehouseName',
      title: t('Warehouse'),
    },
    {
      key: 'boxNumber',
      title: t('Box'),
    },
    {
      key: 'invoiceNumber',
      title: t('Invoice number'),
    },
    {
      key: 'contractNumber',
      title: t('Contract number'),
    },
    {
      key: 'initialPrice',
      title: t('Amount'),
    },
    {
      key: 'vatAmount',
      title: t('VAT'),
    },
    {
      key: 'coverageAmount',
      title: t('Coverage amount'),
    },
    {
      key: 'insurerPrice',
      title: t('Insurers price'),
    },
    {
      key: 'dateFrom',
      title: t('Date from'),
    },
    {
      key: 'dateTo',
      title: t('Date to'),
    },
  ];
};

export const getDepositColumnKeys = (t: TFunction): Column[] => {
  return [
    {
      key: 'warehouse',
      title: t('Warehouse'),
    },
    {
      key: 'invoiceNumber',
      title: t('Invoice number'),
    },
    {
      key: 'contractNumber',
      title: t('Contract number'),
    },
    {
      key: 'customer',
      title: t('Customer'),
    },
    {
      key: 'phone',
      title: t('Phone'),
    },
    {
      key: 'email',
      title: t('Email'),
    },
    {
      key: 'status',
      title: t('Status'),
    },
    {
      key: 'initialDepositAmount',
      title: t('Initial Amount'),
    },
    {
      key: 'depositAmount',
      title: t('Paid amount'),
    },
    {
      key: 'cancelledDepositAmount',
      title: t('Deposit balance'),
    },
    {
      key: 'chargedDepositAmount',
      title: t('Charged'),
    },
    {
      key: 'refundedDepositAmount',
      title: t('Refunded'),
    },
    {
      key: 'contractStartDate',
      title: t('Start date'),
    },
    {
      key: 'createdAt',
      title: t('Created date'),
    },
    {
      key: 'dueDate',
      title: t('Due date'),
    },
  ];
};

export const getBoxesOccupancyColumnKeys = (t: TFunction): Column[] => {
  return [
    {
      key: 'warehouseName',
      title: t('Warehouse'),
    },
    {
      key: 'boxName',
      title: t('Box'),
    },
    {
      key: 'square',
      title: t('Square'),
    },
    {
      key: 'sizeCodeType',
      title: t('Type'),
    },
    {
      key: 'email',
      title: t('Email'),
    },
    {
      key: 'contractNumber',
      title: t('Contract number'),
    },
    {
      key: 'rentType',
      title: t('Rent type'),
    },
    {
      key: 'startDate',
      title: t('Start date'),
    },
    {
      key: 'leaveDate',
      title: t('Leave date'),
    },
    {
      key: 'chargedTo',
      title: t('Charged to'),
    },
    {
      key: 'boxCurrentMonthRate',
      title: t('Box current month rate'),
    },
    {
      key: 'boxCurrentWeekRate',
      title: t('Box current week rate'),
    },
    {
      key: 'boxCurrentDailyRate',
      title: t('Box current daily rate'),
    },
    {
      key: 'contractCurrentPrice',
      title: t('Contract current price'),
    },
    {
      key: 'contractInitialPrice',
      title: t('Contract initial price'),
    },
    {
      key: 'percents',
      title: t('Percents'),
    },
    {
      key: 'discounts',
      title: t('Discounts'),
    },
  ];
};

export const getIncomeStatisticsColumnKeys = (t: TFunction): Column[] => {
  return [
    {
      key: 'rentAmount',
      title: t('Rent amount'),
    },
    {
      key: 'rentCredited',
      title: t('Rent credited'),
    },
    {
      key: 'insuranceAmount',
      title: t('Insurance'),
    },
    {
      key: 'insuranceCredited',
      title: t('Insurance credited'),
    },
    {
      key: 'depositAmount',
      title: t('Deposit'),
    },
    {
      key: 'depositCredited',
      title: t('Deposit credited'),
    },
    {
      key: 'otherAmount',
      title: t('Other'),
    },
    {
      key: 'otherCredited',
      title: t('Other credited'),
    },
    {
      key: 'vatAmount',
      title: t('VAT'),
    },
    {
      key: 'vatCredited',
      title: t('VAT credited'),
    },
  ];
};
